// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right-content__action .anticon[data-v-eef0ebee] {\n  vertical-align: -5px;\n}\n", ""]);
// Exports
module.exports = exports;
